import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut, Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

// export const data = {
//   labels: ['Red', 'Blue', 'Yellow'],
//   datasets: [
//     {
//       label: '# of Votes',
//       data: [12, 19, 3],
//       backgroundColor: [
//         'rgba(98, 79, 209, 1)',
//         'rgba(255, 164, 29, 1)',
//         'rgba(114, 193, 226, 1)',
//       ],
//       borderColor: [
//         'rgba(98, 79, 209, 1)',
//         'rgba(255, 164, 29, 1)',
//         'rgba(114, 193, 226, 1)',
//       ],
//       borderWidth: 1,
//     },
//   ],
// };

export function PieChart({
  Revenue,
  Cost,
  Profit,
  legends = true,
  label,
}: {
  Revenue: number;
  Cost: number;
  Profit: number;
  legends?: boolean;
  label?: string;
}) {
  const options = {
    plugins: {
      legend: {
        display: legends,
      },
    },
  };
  if (Revenue === 0 && Cost === 0 && Profit === 0) {
    Revenue = 33.33;
    Cost = 33.33;
    Profit = 33.33;
    const data = {
      labels: ["Revenue", "Cost", "Profit"],
      datasets: [
        {
          label: label,
          data: [Revenue, Cost, Profit],
          backgroundColor: ["#ffa41d", "#72c1e2", "#67BD8C"],
          borderColor: ["#ffa41d", "#72c1e2", "#67BD8C"],
          borderWidth: 1,
        },
      ],
    };
    return <Pie data={data} options={options} />;
  } else {
    const data = {
      labels: ["Revenue", "Cost", "Profit"],
      datasets: [
        {
          label: label,
          data: [Revenue, Cost, Profit],
          backgroundColor: ["#ffa41d", "#72c1e2", "#67BD8C"],
          borderColor: ["#ffa41d", "#72c1e2", "#67BD8C"],
          borderWidth: 1,
        },
      ],
    };
    return <Pie data={data} options={options} />;
  }
}
